import { render, staticRenderFns } from "./AssessmentTimeUpModal.vue?vue&type=template&id=84870a8e&"
import script from "./AssessmentTimeUpModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentTimeUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports